import { Component, OnInit } from '@angular/core';

interface EventoVeiculo {
  id: number;
  veiculo: string;
  inicio: string; // "08:15"
  fim: string; // "08:45"
  docaId: number; // Identificador da doca
}

interface Doca {
  id: number;
  nome: string;
}

interface Area {
  nome: string;
  docas: Doca[];
}

@Component({
  selector: 'app-new-time-table-outllok2',
  standalone: false,
  templateUrl: './new-time-table-outllok2.component.html',
  styleUrl: './new-time-table-outllok2.component.css'
})

export class NewTimeTableOutllok2Component {
  // Horários da tabela com intervalos quebrados (exemplo)

  horarios: string[] = [
    '08:00', '08:15', '08:30', '08:45', '09:00', '09:15', '09:30', '09:45', '10:00',
    '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45',
    '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', 
    '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45',
    '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45',
    '19:00'
  ];

  // Definição das áreas e suas respectivas docas
  areas: any[] = [
    {
      nome: 'Recebimento Container',
      docas: [
        { id: 1, nome: 'Doca 1' },
        { id: 2, nome: 'Doca 2' },
        { id: 3, nome: 'Doca 3' },
        { id: 4, nome: 'Doca 4' },
        { id: 5, nome: 'Doca 5' }
      ]
    },
    {
      nome: 'Recebimento Sider',
      docas: [
        { id: 6, nome: 'Doca 6' },
        { id: 7, nome: 'Doca 7' },
        { id: 8, nome: 'Doca 8' }
      ]
    },
    {
      nome: 'KD',
      docas: [
        { id: 9, nome: 'Doca 9' },
        { id: 10, nome: 'Doca 10' },
        { id: 11, nome: 'Doca 11' },
        { id: 12, nome: 'Doca 12' }
      ]
    }
  ];
  // Simulação de eventos com horários quebrados (exemplo)
  eventos = [
    { id: 1, veiculo: 'Veículo 1', docaId: 1, inicio: '08:00', fim: '08:30' },
    { id: 2, veiculo: 'Veículo 2', docaId: 2, inicio: '08:00', fim: '09:00' },
    { id: 3, veiculo: 'Veículo 3', docaId: 3, inicio: '09:00', fim: '09:30' },
    { id: 4, veiculo: 'Veículo 4', docaId: 4, inicio: '09:30', fim: '10:00' },
    { id: 5, veiculo: 'Veículo 5', docaId: 5, inicio: '11:00', fim: '11:30' },
    { id: 5, veiculo: 'Veículo 6', docaId: 6, inicio: '12:00', fim: '13:30' },
    { id: 5, veiculo: 'Veículo 7', docaId: 7, inicio: '10:00', fim: '10:30' },
    { id: 5, veiculo: 'Veículo 8', docaId: 8, inicio: '10:00', fim: '10:30' },
    { id: 5, veiculo: 'Veículo 9', docaId: 9, inicio: '10:00', fim: '10:30' },
    { id: 5, veiculo: 'Veículo 10', docaId: 10, inicio: '10:00', fim: '12:30' },
  ];

  getEventoParaDocaEHorario(docaId: number, horario: string) {
    const horaFormatada = new Date(`1970-01-01T${horario}:00`);
    return this.eventos.find(evento => 
      evento.docaId === docaId &&
      new Date(`1970-01-01T${evento.inicio}:00`) <= horaFormatada &&
      new Date(`1970-01-01T${evento.fim}:00`) >= horaFormatada
    );
  }

  // getRowSpan(evento: EventoVeiculo): number {
  //   const indexInicio = this.horarios.indexOf(evento.inicio);
  //   const indexFim = this.horarios.indexOf(evento.fim);
  //   console.log(indexFim - indexInicio)
  //   return indexFim - indexInicio;
  // }

  // Função para retornar o estilo do evento (exemplo)
  getEstiloEvento(evento: any) {
    if (!evento) {
      return {}; // Caso não exista evento, retorna um estilo vazio
    }
    return {
      'background-color': '#4CAF50', // Cor de fundo verde
      'color': 'white',
      'padding': '5px',
      'border-radius': '5px'
    };
  }

  shouldDisplayEvento(docaId: number, horario: string): EventoVeiculo | null {
    const evento = this.getEventoParaDocaEHorario(docaId, horario);
    if (!evento) return null;  
    const indexHorarioInicio = this.horarios.indexOf(evento.inicio);
    return this.horarios.indexOf(horario) === indexHorarioInicio ? evento : null;
  }

  getRowSpanHeight(evento: EventoVeiculo): string {
    const rowHeight = 50; // Altura base por linha
    const rowSpan = this.getRowSpan(evento);
    return `${rowHeight * rowSpan}px`;
  }
  
  // getRowSpanClass(evento: EventoVeiculo): string {
  //   return 'row-span-' + this.getRowSpan(evento);
  // }
  
  getRowSpan(evento: EventoVeiculo): number {
    const indexInicio = this.horarios.indexOf(evento.inicio);
    const indexFim = this.horarios.indexOf(evento.fim);
    return indexFim - indexInicio + 1;
  }
}




